import { combineReducers } from 'redux';
import login from './login.reducer';
import tenders from './tenders.reducer';

export default combineReducers({
    login,
    tenders
});